"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./progressBar.sass");

var ProgressBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProgressBar, _Component);

  function ProgressBar() {
    (0, _classCallCheck2.default)(this, ProgressBar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProgressBar).apply(this, arguments));
  }

  (0, _createClass2.default)(ProgressBar, [{
    key: "renderPercentage",
    value: function renderPercentage() {
      var _this$props = this.props,
          max = _this$props.max,
          value = _this$props.value;
      var percentage = 100 * value / max;
      var valueStyle = {
        width: 10000 / percentage + '%'
      };
      var text = Math.round(percentage) + '%';
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "progress-bar",
        style: {
          width: percentage + '%'
        }
      }, percentage > 0 && _react.default.createElement("span", {
        className: "progress-value",
        style: valueStyle
      }, text)), _react.default.createElement("div", {
        className: "progress-value"
      }, text));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          big = _this$props2.big,
          medium = _this$props2.medium,
          indeterminate = _this$props2.indeterminate,
          inline = _this$props2.inline;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('progress', {
          'progress--big': big,
          'progress--medium': medium,
          'progress--indeterminate': indeterminate,
          'progress--inline': inline
        }, className)
      }, !indeterminate && this.renderPercentage());
    }
  }]);
  return ProgressBar;
}(_react.Component);

exports.default = ProgressBar;
(0, _defineProperty2.default)(ProgressBar, "defaultProps", {
  max: 100
});
ProgressBar.propTypes = process.env.NODE_ENV !== "production" ? {
  max: _propTypes.default.number,
  value: _propTypes.default.number,
  className: _propTypes.default.string,
  big: _propTypes.default.bool,
  medium: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  inline: _propTypes.default.bool
} : {};